import columns from "./columns";
import formFields from "./formFields";
import previewFields from "./previewFields";

export default {
    entityName: "locationCategories",
    pageTitle: "Location Categories",
    columns,
    formFields,
    previewFields,
    formOptions: {},
};
